import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'

import { useHideNativeNavigation, useHideWebHeader } from '@/layout/providers/LayoutProvider'
import { AudioPlayer } from '../../components/AudioPlayer'
import { ContentItemDetailLayout } from '../../components/ContentItemDetailLayout'
import { RichText } from '../../components/RichText'
import { useContentById } from '../../hooks/useContent'

type Props = {
  preview?: boolean
  draft?: boolean
}

export const AudioDetailPage = ({ preview, draft }: Props) => {
  const [start, setStart] = useState(false)

  const { id } = useParams()
  const navigate = useNavigate()
  const theme = useTheme()

  const { data: audioContent, isLoading } = useContentById(id, draft)

  // Hide navigation on native devices
  useHideNativeNavigation()
  useHideWebHeader()

  const onStart = () => {
    setStart(true)
  }

  if (!audioContent?.audio) {
    return null
  }

  const AudioBanner = (
    <div style={{ flex: 1 }}>
      <AudioPlayer
        title={audioContent.title}
        audioUrl={audioContent.audio.url}
        posterUrl={audioContent.featuredImage?.url}
        start={start}
      />

      {start ? null : (
        <PlayIconContainer onClick={onStart}>
          <BackgroundBlur />
          <PlayIcon icon={['fas', 'play']} color={theme.Colors.Background.White} />
        </PlayIconContainer>
      )}
    </div>
  )

  return (
    <ContentItemDetailLayout
      loading={isLoading}
      bannerContent={AudioBanner}
      onGoBack={preview ? undefined : () => navigate(-1)}
      preview={preview}
    >
      {audioContent?.contentBlocks ? <RichText contentBlocks={audioContent.contentBlocks} /> : null}
    </ContentItemDetailLayout>
  )
}

const PlayIconContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
  width: 5rem; /* Equivalent to w-20 */
  height: 5rem; /* Equivalent to h-20 */
  border-radius: 0.375rem; /* Equivalent to rounded-md */
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5); /* bg-base-black with opacity-50 */
  cursor: pointer;
`

const BackgroundBlur = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`

const PlayIcon = styled(FontAwesomeIcon)`
  width: 1.5rem; /* Equivalent to w-6 */
  height: 1.5rem; /* Equivalent to h-6 */
  stroke: white;
  z-index: 10;
  cursor: pointer;
`
